export default "__VITE_ASSET__DMB8yl79__"